export type PartnerId = 'northfield' | 'halcyon' | 'meridian' | 'ashgrove' | 'lumen' | 'stillwater'

export interface Partner {
    id: PartnerId
    name: string
}

/** Invented partner and press names used as social proof. */
export const PARTNERS: Array<Partner> = [
    { id: 'northfield', name: 'Northfield' },
    { id: 'halcyon', name: 'Halcyon' },
    { id: 'meridian', name: 'Meridian Trust' },
    { id: 'ashgrove', name: 'Ashgrove & Co' },
    { id: 'lumen', name: 'Lumen Capital' },
    { id: 'stillwater', name: 'Stillwater' }
]

export const HERO_PARTNERS: Array<PartnerId> = ['northfield', 'halcyon', 'meridian', 'ashgrove', 'lumen']
